import React from 'react';
import { ENROLLMENT_STATUSES, ENROLLMENT_BULK_ACTIONS } from 'src/pages/enrollments/constants';
import EnrollmentWorkqueue from 'src/pages/enrollments/pages/EnrollmentWorkqueue';

const OpenEnrollments = () => {
  const enrollmentStatus = `${ENROLLMENT_STATUSES.open},${ENROLLMENT_STATUSES.inReview}`;

  return (
    <EnrollmentWorkqueue
      showEnrollmentAging
      enrollmentStatus={enrollmentStatus}
      showSelectMultipleEnrollments
      availableBulkActions={ENROLLMENT_BULK_ACTIONS.open}
    />
  );
};

export default OpenEnrollments;
